import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-office-rep-in-details',
  // standalone: true,
  // imports: [],
  templateUrl: './office-rep-in-details.component.html',
  styleUrl: './office-rep-in-details.component.scss'
})
export class OfficeRepInDetailsComponent {
   PaymentBookOffInDFormBenas: any[] = [];
      PaymentbookOffInDTotal2: number = 0;
      startDate: string = '';
       currentDate= new Date();
      endDate: string = '';
      // officeRepName: string = ''; // ✅ Added filter field
      reportType = 'Office Rep InDetails';
      loading = false;
      officerepwise: any;
      repName: any;
  show: boolean;
    
      constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<OfficeRepInDetailsComponent>,
        private service: DigisubservicesService
      ) {}
    
      ngOnInit(): void {
        debugger;
        console.log('Dialog data received:', this.data);
    
        this.startDate = this.data?.start_date || this.data?.startDate || '';
        this.endDate = this.data?.end_date || this.data?.endDate || '';
         this.officerepwise = this.data?.office_rep_name || this.data?.officerepwise || ''; // ✅ fetch from dialog data if passed
         this.repName = this.data?.rep_name || this.data?.repName || '';
      
    
        if (!this.startDate || !this.endDate) {
          console.warn('⚠️ Missing start_date or end_date in dialog data');
          return;
        }
    
        this.getReportData();
      }
    
      // ✅ Fetch Report Data with Filter
      getReportData(): void {
        debugger;
        this.loading = true;
    
        const payload: any = {
          start_date: this.startDate,
          end_date: this.endDate,
          // office_rep_name:this.officerepwise,
          office_rep_name: this.officerepwise,
          rep_name: this.repName
        };
    
      
    
        console.log('📤 Payload being sent to API:', payload);
    
        this.service.getBookPaymentRegiOffInDetails1(payload).subscribe({
          next: (res: any) => {
            console.log('✅ API response received:', res);
            this.PaymentBookOffInDFormBenas = res || [];
            this.calculateGrandTotal();
            this.loading = false;
          },
          error: (err) => {
            console.error('❌ Error fetching report data:', err);
            this.loading = false;
          }
        });
      }
    
      // ✅ Dynamic Grand Total Calculation
      calculateGrandTotal(): void {
        let total = 0;
    
        for (let office of this.PaymentBookOffInDFormBenas) {
          if (office.rep_data && Array.isArray(office.rep_data)) {
            for (let rep of office.rep_data) {
              if (rep.book_sellers && Array.isArray(rep.book_sellers)) {
                for (let seller of rep.book_sellers) {
                  total += parseFloat(seller.rcv_amt) || 0;
                }
              }
            }
          }
        }
    
        this.PaymentbookOffInDTotal2 = total;
        console.log('✅ Calculated Grand Total:', this.PaymentbookOffInDTotal2);
      }
    
      // ✅ Excel Export
      // exportExcel(fileName: string): void {
      //   const element = document.getElementById('print-section');
      //   if (!element) return;
    
      //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
      //   XLSX.utils.book_append_sheet(wb, ws, 'Report');
      //   XLSX.writeFile(wb, `${fileName}.xlsx`);
      // }
    
      // ✅ Print Function
printPageA4() {
  const printContent = document.getElementById('print-section');
  const WindowPrt = window.open('', '', 'width=1200,height=900');

  WindowPrt.document.write(`
    <html>
      <head>
      
  <title>.</title>
        <style>

          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          @page {
            size: A4 portrait;
            margin: 10mm 8mm 10mm 15mm;
          }

          body {
            margin: 0;
            font-family: Arial, sans-serif;
            font-size: 14px !important;
            color: #000;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 14px !important;
          }

          th, td {
            border: 1px solid black !important;
             white-space: nowrap !important;
            padding: 4px 6px !important;
            vertical-align: middle;
          }

          thead th {
            background: #f1f1f1 !important;
            font-weight: bold;
          }

          .grand-total-row td {
            background: #c8753f !important;
            font-weight: bold;
            color: #000 !important;
          }

          /* Prevent table row breaking */
          tr, td, th {
            page-break-inside: avoid !important;
          }

          thead { 
            display: table-header-group;
          }

          tfoot {
            display: table-row-group !important;
          }

          @media print {
            .noPrint { display: none !important; }
          }

        </style>

      </head>

      <body>
        ${printContent?.innerHTML}
      </body>
    </html>
  `);

  WindowPrt.document.close();
  WindowPrt.focus();

  setTimeout(() => {
    WindowPrt.print();
    WindowPrt.close();
  }, 500);
}
exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }









  
    
    
    
    
    
    
    }
    
  
  
  


